import React from "react";

const TextForm = ({value, handleOnChange}) => {
  return <textarea className="input" type="text" value={value} onChange={handleOnChange}></textarea>;
};

export default TextForm;
